import React, { Component } from 'react';
import './LandingPage.css'

export default class LandingPage extends Component { 
    render() {
      return (
        <div className="about-app">
            <p>
              Fast Food Evolved is the ultimate tool to satisfy your cravings. With tons of options from fast food establishments around the world, you have the opportunity to create the most delicious fast food hybrid imaginable.
            </p> 
        </div>
      )
    }
  }